import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async watch(event) {
    event.preventDefault();
    const newTab = window.open("", "_blank");

    try {
      const response = await fetch(this.element.dataset.url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok && data.success) {
        if (newTab) {
          newTab.location.href = data.url;
        }

        const targetElement = document.getElementById(data.target_id);
        if (targetElement) {
          targetElement.outerHTML = data.html;
        }
      } else {
        if (newTab) {
          newTab.close();
        }
        setTimeout(() => {
          if (data.html) {
            document.documentElement.innerHTML = data.html;
            window.scrollTo(0, 0);
          }
        }, 10);
      }
    } catch {
      if (newTab) {
        newTab.close();
      }
    }
  }
}
